module.exports = __webpack_public_path__ + "img/sobre_territorio_matachaves_01.1e49e688.png";